module.exports = __webpack_public_path__ + "img/icon-order.987c2c2d.png";